// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"580":"267e33b9","787":"637ce6b0","799":"db2c9094"}[chunkId] + ".chunk.js";
};